// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@awc/Overrides/Widgets/Brand/BrandGallery";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

listStyles.imageContainer = {
    css: css`
        display: grid;
        ${({ repeatNum }: any) =>
            repeatNum
                ? css`
                      grid-template-columns: repeat(${repeatNum}, 1fr);
                  `
                : css`
                      grid-template-columns: repeat(auto-fit, 149px);
                  `}
        gap: 16px 25px;

        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(auto-fit, 149px);
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(2, minmax(0, 164px));
            gap: 16px;
            justify-content: center;
        }
    `,
};

listStyles.image = {
    mergeCss: true,
    height: "100px",
    css: css`
        max-width: 149px;
        ${xScreen("lte", "sm")} {
            max-width: 164px;
            height: 110px;
        }
    `,
};

listStyles.brandLink = {
    mergeCss: true,
    typographyProps: {
        css: css`
            text-align: center;
        `,
    },
    css: css`
        justify-content: center;
        width: 100%;
        margin-top: 12px;
    `,
};

listStyles.titleText = {
    variant: "h3",
    as: "h2",
    css: css`
        border-width: 20px;
        text-align: center;
    `,
};

listStyles.link = {
    css: css`
        justify-content: center;
    `,
}